import { isRichContent, toPlainText } from '../services/rich-content';
export const getFormFieldLabel = formField => {
  var _formField$view;
  const label = (_formField$view = formField.view) == null ? void 0 : _formField$view.label;
  if (!label) {
    return null;
  }
  if (isRichContent(label)) {
    return toPlainText(label);
  }
  return label;
};
//# sourceMappingURL=get-form-field-label.js.map